angular.module('wbDashboard').controller('MilestoneControllerAurea', ['$scope', 'User', 'Milestone', function ($scope, User, Milestone) {

    /*jshint -W030 */
    $scope.forms || ($scope.forms = {});
    /*jshint +W030 */

    $scope.pageData = {
        sending: false,
        errorMsg: null
    };

    $scope.milestone = {};
    $scope.MS = Milestone;

    $scope.year = (new Date()).getFullYear();

    $scope.$watch(User.getOverview, function(overview) {
        $scope.overview = overview;
    });

}]);
